import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.01 13a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1m1 3c0 .552-.446 1-.995 1h-.01a1 1 0 0 1-.995-1c0-.552.445-1 .995-1h.01c.55 0 .995.448.995 1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 1.005a5 5 0 0 0-3.814 1.767 5 5 0 0 0-5.413 5.4 5 5 0 0 0 0 7.656 5 5 0 0 0 5.412 5.4 5 5 0 0 0 7.642 0 5.002 5.002 0 0 0 5.402-5.414 4.998 4.998 0 0 0 0-7.628 4.998 4.998 0 0 0-5.415-5.414A5 5 0 0 0 12 1.005m-1.44 2.369a3 3 0 0 1 3.968 1.015 1 1 0 0 0 1.061.437 3 3 0 0 1 3.585 3.585 1 1 0 0 0 .438 1.062 3 3 0 0 1 0 5.055 1 1 0 0 0-.438 1.06 3 3 0 0 1-3.577 3.586 1 1 0 0 0-1.06.44 3 3 0 0 1-5.063 0 1 1 0 0 0-1.063-.44 3 3 0 0 1-3.585-3.577 1 1 0 0 0-.441-1.062 3 3 0 0 1 0-5.07 1 1 0 0 0 .441-1.062 3 3 0 0 1 3.585-3.577 1 1 0 0 0 1.062-.437 3 3 0 0 1 1.086-1.015Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }